import { isBefore, isValid, parse } from 'date-fns';

export const getFutureDate = (value: number) => {
  const currentDate = new Date();

  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const year = currentDate.getFullYear() + value;

  return `${day}/${month}/${year}`;
};

export const isValidDate = (date: string) => {
  const dateValidation = parse(date, 'dd/MM/yyyy', new Date());
  const currentDate = new Date();

  if (!isValidFormat(date) || !isValid(dateValidation)) {
    return {
      isValid: false,
      error: 'Insira uma data válida no formato DD/MM/AAAA.'
    };
  }

  if (isBefore(dateValidation, currentDate)) {
    return {
      isValid: false,
      error: 'Insira uma data futura.'
    };
  }

  return {
    isValid: true,
    error: ''
  };
};

function isValidFormat(date: string) {
  const pattern = /^\d{2}\/\d{2}\/\d{4}$/;
  return pattern.test(date);
}
